import { Input, InputNumber } from 'antd';
import { ReactElement } from 'react';

import FormItemWithLabel from '../../../components/Form/FormItemWithLabel';
import { DocumentMedicalBillEntity } from '../../../generated-api';
import { FormComponentProps } from '../defs/types';

export function MedicalBillFormInputs({ entity }: FormComponentProps<DocumentMedicalBillEntity>): ReactElement {
  return (
    <>
      <FormItemWithLabel label="日付" name="date">
        <Input defaultValue={entity.date} />
      </FormItemWithLabel>
      <FormItemWithLabel label="金額" name="amount">
        <InputNumber defaultValue={entity.amount} />
      </FormItemWithLabel>
      <FormItemWithLabel label="住所" name="address">
        <Input defaultValue={entity.address} />
      </FormItemWithLabel>
      <FormItemWithLabel label="医療機関名" name="hospital_name">
        <Input defaultValue={entity.hospital_name} />
      </FormItemWithLabel>
      <FormItemWithLabel label="受診者名" name="patient_name">
        <Input defaultValue={entity.patient_name} />
      </FormItemWithLabel>
    </>
  );
}
